export default "__VITE_ASSET__BXHStryh__"